import React from 'react';

import './styles.css';

interface VideoComponentProps {
  value?:any,
  label:string,
  style:any
}

const VideoComponent: React.FC<VideoComponentProps> = ({ label, value, style, ...rest }) => {
  let VideoFrame = value.replace('open?id=','file/d/')+"/preview";
  console.log(VideoFrame)
  return (
    <div className="input-block">
{/*       <label htmlFor="labelVideo">{label}</label>
 */}      <div className="video">
      <iframe title="video" src={VideoFrame} width="100%" height="300" allow="autoplay" style={{...style, border: "none"}}></iframe>
      </div>
  
    </div>
  );
}

export default VideoComponent;
